export default __webpack_public_path__ + "47d0618cb4832f9edf76a2617364a76d.png";